import { Box, IconButton, styled, TableCell, Tooltip } from "@mui/material"
import React, { ReactNode } from "react"
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ImportExportOutlinedIcon from '@mui/icons-material/ImportExportOutlined';

interface ISortableFieldHeaderProps extends React.PropsWithChildren {
    currentField?: string,
    currentDirection?: "a" | "d",
    sortField: string,
    onSort: (field: string, direction: "a"|"d") => void,
    elementType?: "tableCell",
    className?: string
}

const SortableFieldHeader: React.FC<ISortableFieldHeaderProps> = (props: ISortableFieldHeaderProps) => {

    const InlineWrapper = styled(Box)({
        display: "inline-flex",
        verticalAlign: "middle",
        fontWeight: "bold",
    });

    const renderSortIcon = (): ReactNode => {
        if (props.currentField === props.sortField) {
            if (props.currentDirection === 'a') {
                return <Tooltip title="sort descending">
                <IconButton onClick={() => props.onSort(props.sortField, "d")}>
                    <ArrowCircleDownIcon color="primary" />
                </IconButton>
                </Tooltip>
            } else {
                return <Tooltip title="sort ascending">
                <IconButton onClick={() => props.onSort(props.sortField, "a")}>
                    <ArrowCircleUpIcon color="primary" />
                </IconButton>
                </Tooltip>
            }
        } else {
            return <Tooltip title="sort on this field">
                <IconButton onClick={() => props.onSort(props.sortField, "a")}>
                <ImportExportOutlinedIcon color="disabled" />
            </IconButton>
            </Tooltip>
        }
    }

    const renderHeader = (): ReactNode => {
        return (
            <>
            <InlineWrapper>
                {renderSortIcon()}
            </InlineWrapper>
            <InlineWrapper>
                <Box>{props.children}</Box>
            </InlineWrapper>
            </>
        )
    }

    return (!props.elementType || props.elementType === 'tableCell') ?
                <TableCell className={props.className ?? ""}>
                    {renderHeader()}
                </TableCell>
            : <>{renderHeader()}</>
    
}

export default SortableFieldHeader;
